import React from 'react';
import PropTypes from 'prop-types';
import IconWarning from '../../images/icon-warning.svg';
import * as styles from './style';

const FormFooter = ({ cancelAction, nextAction, errorMessage, textSubmit }) => {
  return (
    <styles.Container>
      <styles.Content>
        <styles.CancelButton
          id="btn-form-footer-cancel"
          className="btn-footer-cancel"
          onClick={cancelAction}
        >
          Cancelar
        </styles.CancelButton>
        {errorMessage && (
          <styles.ErrorContainer>
            <styles.WarningIcon src={IconWarning} />
            <styles.Message>{errorMessage}</styles.Message>
          </styles.ErrorContainer>
        )}
        <styles.ContinueButton
          id="btn-form-footer-submit"
          className="btn-footer-submit"
          onClick={nextAction}
        >
          {textSubmit}
        </styles.ContinueButton>
      </styles.Content>
    </styles.Container>
  );
};

FormFooter.propTypes = {
  nextAction: PropTypes.func,
  cancelAction: PropTypes.func,
  errorMessage: PropTypes.string,
  textSubmit: PropTypes.string,
};

FormFooter.defaultProps = {
  textSubmit: 'Próximo',
};

export default FormFooter;



// WEBPACK FOOTER //
// ./src/components/FormFooter/index.js